export enum AlertVariant {
  INFORMATIVE = "informative",
  ERROR = "error",
  WARNING = "warning",
  SUCCESS = "success",
}
